import script from "./AboutCases.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutCases.vue?vue&type=script&setup=true&lang=js"

import "./AboutCases.vue?vue&type=style&index=0&id=6fa8be8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fa8be8f"]])

export default __exports__